"use client";

import Link from "next/link";
import { Zap } from "lucide-react";

const RECOMMENDED_PAIRS = [
  { title: "보톡스 vs 필러", items: ["보톡스", "필러"], desc: "주름 개선 대표 시술 비교" },
  { title: "슈링크 vs 인모드", items: ["슈링크", "인모드"], desc: "리프팅 시술 비교" },
  {
    title: "레이저토닝 vs 피코레이저",
    items: ["레이저토닝", "피코레이저"],
    desc: "색소 개선 비교",
  },
  {
    title: "울쎄라 vs 슈링크유니버스",
    items: ["울쎄라", "슈링크유니버스"],
    desc: "초음파 리프팅 비교",
  },
];

export function RecommendedPairs() {
  return (
    <section className="mt-8">
      <div className="mb-4 flex items-center gap-2">
        <Zap className="h-4 w-4 text-violet-500" />
        <h3 className="text-sm font-bold">인기 비교</h3>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {RECOMMENDED_PAIRS.map((pair) => (
          <Link
            key={pair.title}
            href={`/wiki/compare?items=${pair.items.map(encodeURIComponent).join(",")}`}
            className="card-hover flex flex-col rounded-2xl border border-gray-200 bg-white p-5 transition-all hover:border-violet-200"
          >
            <span className="mb-1 text-base font-bold">{pair.title}</span>
            <span className="text-muted-foreground text-xs">{pair.desc}</span>
            <div className="mt-3 flex gap-2">
              {pair.items.map((item) => (
                <span
                  key={item}
                  className="rounded-full bg-violet-50 px-3 py-1 text-xs font-semibold text-violet-700"
                >
                  {item}
                </span>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
